import { cn } from "@/shared/lib/utils";
import { forwardRef, type ComponentProps } from "react";


const Input = forwardRef<HTMLInputElement, ComponentProps<"input">>(
  ({ className, type, ...properties }, reference) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={reference}
        {...properties}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
